import axiosPrivate from "@services/axiosPrivate"
import { ADD_DIAGNOSIS } from "src/constants"

export const addDiagnosis = (data) => {
    return axiosPrivate.post(ADD_DIAGNOSIS, data, {
        withCredentials: true,
    })
}
